<template lang="pug">
.filtering
	Loader(v-if="!loaded")
	section(v-if="ready")
		Highlights(v-if="$root.highlights", :highlights="$root.highlights")
		Search
		Facets
		Items(:items="$root.items")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from './components/Loader.vue'
import Search from './components/Search.vue'
import Facets from './components/Facets.vue'
import Items from './components/Items.vue'
import Highlights from './components/Highlights.vue'
export default {
	name: "Filtering",
	components: {
		Loader,
		Search,
		Facets,
		Items,
		Highlights
	},
	data() {
		return {
			loaded: false
		};
	},
	computed: {
		...mapGetters(["ready"]),
	},
	methods: {
		...mapActions(["fetchData"]),
		hideLoader() {
			if (this.ready) {
				setTimeout(() => {
					this.loaded = true;
				}, 2500);
			}
		}
	},
	watch: {
		ready() {
			this.hideLoader();
		}
	},
	async created() {
		await this.fetchData(this.$root.facetsEndpoint);
	},
};
</script>

<style scoped lang="scss">
.filtering {
	display: flex;
	flex-direction: column;
	min-height: calc(500px + 5.5rem);
	position: relative;
}
</style>